/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { seguridad } from '../../conexiones';
import IModulo from './entidades/modulo';

export default class ModeloModulo {
    public consultarModulo() {  
        return manejadorRest<IRespuesta<IModulo>>(() => seguridad.get('Modulo/ConsultarListaModulo'));
    }
    public crearModulo(modulo: IModulo) {
        return manejadorRest<IRespuesta<IModulo>>(() => seguridad.post('Modulo/GuardarModulo', modulo));
    }
    public editarModulo(modulo: IModulo) {
        return manejadorRest<IRespuesta<IModulo>>(() => seguridad.put('Modulo/EditarModulo', modulo));
    }
    public eliminarModulo(modulo: IModulo) {
        return manejadorRest<IRespuesta<IModulo>>(() => seguridad.delete('Modulo/EliminarModulo', modulo));
    }
}
